// extracted by mini-css-extract-plugin
module.exports = {"accordion-item":"R_cW","accordionItem":"R_cW","open":"R_cX","icon":"R_bj","toogler":"R_cY","title":"R_bF","content":"R_g","content-body":"R_cZ","contentBody":"R_cZ","text":"R_cC"};